import { DialogTitle, DialogContent, Typography } from '@mui/material';
import WrestlerStatsForm from './WrestlerStatsForm';

export default function WrestlerStatsStep() {
    return (
        <>
            <DialogTitle>Wrestler Stats</DialogTitle>
            <DialogContent>
                <Typography sx={{ paddingTop: 1, paddingBottom: 3 }}>
                    Enter the wrestler's weight to determine their division and class.
                </Typography>

                <WrestlerStatsForm />
            </DialogContent>
        </>
    );
}
